import { useLayoutEffect, useRef, useState } from "react";
import ribbonBanner from "@assets/web-v3-images/daily-reward-el-banner.png";

/**
 * Ruy băng đỏ mang tên giải, treo phía trên thân máy.
 *
 * Nền là PNG có sẵn đuôi én + viền vàng (tỉ lệ file 624×195); chữ tên giải phủ
 * chính giữa thân băng bằng cùng kỹ thuật xếp lớp như GuessTicker/PrizeShowcase.
 */
const PrizeNameRibbon = ({ name }) => {
  const boxRef = useRef(null);
  const textRef = useRef(null);
  // Tỉ lệ thu nhỏ để tên dài luôn vừa bề ngang dải đỏ (tên ngắn giữ nguyên cỡ,
  // canh giữa như design). Đo bằng offsetWidth — transform:scale không đổi kích
  // thước layout nên không gây vòng lặp đo.
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const box = boxRef.current;
    const text = textRef.current;
    if (!box || !text) return undefined;

    const fit = () => {
      const available = box.clientWidth;
      const natural = text.offsetWidth;
      setScale(natural > available ? available / natural : 1);
    };

    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(box);
    return () => ro.disconnect();
  }, [name]);

  return (
    <div className="@container relative mx-auto w-[74%] max-w-[652px]">
      <img
        src={ribbonBanner}
        alt=""
        className="aspect-624/195 w-full object-contain"
      />

      {/* Chữ tên giải: overlay đúng khuôn thân băng ĐỎ (chỉ chiếm ~nửa trên của
          PNG; nửa dưới là nếp gấp + đuôi én) nên định vị theo % thay vì inset-0 —
          canh giữa cả trục ngang lẫn dọc trong dải đỏ.

          Nhân đôi glyph xếp chồng bằng grid (giống GuessTicker/PrizeShowcase):
            - lớp dưới: viền cam-đỏ #E5451E (stroke) + đổ bóng đen của design
            - lớp trên: mặt chữ gradient vàng #FEF7C3 → #FDE272 */}
      <div
        ref={boxRef}
        className="absolute inset-x-[13%] top-[3%] bottom-[43%] grid place-items-center justify-center overflow-hidden"
      >
        <p
          ref={textRef}
          style={{ transform: `scale(${scale})` }}
          className="inline-grid w-max origin-center justify-items-center whitespace-nowrap text-center text-[9cqw] font-extrabold leading-none"
        >
          <span
            aria-hidden="true"
            className="col-start-1 row-start-1 text-[#E5451E] [-webkit-text-stroke:1cqw_#E5451E] [text-shadow:0_0.6cqw_0.6cqw_rgba(0,0,0,0.25)]"
          >
            {name}
          </span>
          <span className="col-start-1 row-start-1 text-transparent bg-linear-to-b from-[#FEF7C3] to-[#FDE272] bg-clip-text">
            {name}
          </span>
        </p>
      </div>
    </div>
  );
};

export default PrizeNameRibbon;
